export type SortOption = 'az' | 'za' | 'newest' | 'oldest';

export const SORT_LABELS: Record<SortOption, string> = {
  az: 'A → Z',
  za: 'Z → A',
  newest: 'Newest',
  oldest: 'Oldest',
};

export interface SectionState {
  query: string;
  sort: SortOption;
  collapsed: boolean;
}

export interface TreeSectionConfig {
  key: 'satellites' | 'geofeatures' | 'ground';
  title: string;
  icon: React.ReactNode;
  emptyText: string;
  onAdd?: () => void | Promise<void>;
  disabled?: boolean;
  itemCount: number;
  children: React.ReactNode;
}
